<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>{{ title }}</h1>
      <v-row>
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="3"
          offset-md="6"
          class="classPadding"
        >
          <v-text-field
            v-model="search"
            append-outer-icon="mdi-magnify"
            label="Search"
            class="classPadding"
            @click:append-outer="triggerSearch"
            @keyup.enter="triggerSearch"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="3" class="classPadding">
          <v-select
            :items="searchByItems"
            item-text="text"
            item-value="value"
            v-model="searchBy"
            class="classPadding"
          ></v-select>
        </v-col>
      </v-row>
      <v-data-table :items="items" :headers="headers" :loading="loading">
        <template v-slot:item.actions="{ item }">
          <v-btn icon text @click.prevent="select(item)">
            <v-icon>mdi-arrow-right-bold</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.startOfWork="{ item }">
          <span>{{ item.startOfWork | dateFormat }}</span>
        </template>
        <template v-slot:item.requestedDate="{ item }">
          <span>{{ item.requestedDate | dateFormat }}</span>
        </template>
        <template v-slot:item.dateApproved="{ item }">
          <span>{{ item.dateApproved | dateFormat }}</span>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>
<script>
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/pr";
export default {
  metaInfo: {
    title: "Personnel Requisition Summary",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  data: () => ({
    title: "Personnel Requisition Summary",
    classPadding: "my-0 py-0",
    items: [],
    headers: [
      { text: "", value: "actions", sortable: false },
      { text: "PRF No.", value: "prfNo" },
      { text: "Designation", value: "desDesc" },
      { text: "No. of Need", value: "noOfNeed" },
      { text: "Start of Work", value: "startOfWork" },
      { text: "Requested By", value: "requestedByFullName" },
      { text: "Requested Date", value: "requestedDate" },
      { text: "Approved By", value: "approvedByFullName" },
      { text: "Approved Date", value: "dateApproved" },
      { text: "Status", value: "status" }
    ],
    searchBy: "prfNo",
    search: null,
    searchByItems: [
      {
        text: "PRF No.",
        value: "prfNo"
      },
      {
        text: "Payroll Location",
        value: "locID"
      },
      {
        text: "Designation",
        value: "desDesc"
      },
      {
        text: "Requested By",
        value: "requestedBy"
      },
      {
        text: "Requested Date",
        value: "requestedDate"
      },
      {
        text: "Approved By",
        value: "approveBy"
      },
      {
        text: "Status",
        value: "status"
      }
    ],
    loading: false
  }),
  methods: {
    triggerSearch() {
      this.loading = true;
      var data = {
        searchCategory: this.searchBy,
        searchValue: this.search
      };
      this.$axios
        .post(`${API_ENDPOINT}/summary`, data)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    select(item) {
      // eventBus.$emit("SELECTED_PRF_STATUS", item.status);
      this.$router.push(`/pr-summary/${item.prfNo}`);
    }
  },
  created() {
    this.triggerSearch();

    this.getUserAccessRights("PRSUMMARY");
  }
};
</script>